import { createContext } from 'react';

export const AuthContext = createContext({
  isDoctorLoggedIn: false,
  isPateintLoggedIn: false,
  isPharmacyLoggedIn: false,
  doctor: null, // ✅ Updated to hold full doctor object
  patient: null, // ✅ Updated to hold full patient object
  pharmacy: null, // ✅ Updated to hold full pharmacy object
  doctorId: null,
  patientId: null,
  pharmacyId: null,
  token: null,
  Plogin: (user) => {}, // user will be full patient object
  Plogout: () => {},
  Dlogin: (user) => {}, // user will be full doctor object
  Dlogout: () => {},
  Phlogin: (user) => {},
  Phlogout: () => {}
});